export default "__VITE_ASSET__C_7v2ALg__"